import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { mapTo, tap } from 'rxjs/operators';
import { CampaignOffersQuery } from './campaign-offers.query';
import { CampaignOffersStore } from './campaign-offers.store';
import { CampaignOffers } from './campaignoffers.model';
import { ApiService } from '../shared/services/core/api.service';

@Injectable({ providedIn: 'root' })
export class CampaignOffersService {
  constructor(
    private api: ApiService,
    private campaignOffersStore: CampaignOffersStore,
    private campaignOffersQuery: CampaignOffersQuery
  ) {}
  fetchOffers(): Observable<null> {
    const request$: Observable<null> = this.api.getAnySingle<CampaignOffers>('purchases/entitlements').pipe(
      tap((response) => {
        this.campaignOffersStore.set([response]);
      }),
      mapTo(null)
    );
    return this.campaignOffersQuery.getHasCache() ? of(null) : request$;
  }
}
